module.exports = __webpack_public_path__ + "static/media/temp-indicator-2-map-only.bdf65f49.svg";